// test2587
(2587 && 0);
